import React from 'react';

const PrivacyPolicyPage: React.FC = () => {
  const lastUpdated = "January 7, 2025";

  return (
    <div className="container mx-auto px-4 py-8 text-foreground">
      <h1 className="text-4xl font-bold mb-8 text-primary text-center">Privacy Policy</h1>
      <p className="mb-6 text-lg text-center text-muted-foreground">
        Last Updated: {lastUpdated}
      </p>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">1. Information We Collect</h2>
        <p className="text-muted-foreground leading-relaxed">
          We collect information you provide directly to us when you create an account, use our services, 
          or communicate with us. This may include your name, email address, payment information, 
          and any video content you upload or create through our AI-powered video processing platform.
        </p>
        <p className="text-muted-foreground leading-relaxed mt-2">
          We also automatically collect certain information when you use our Service, such as your IP address, 
          browser type, operating system, and usage data. Our consolidated platform architecture may collect 
          performance and system metrics to ensure optimal service delivery. We may use cookies and similar tracking technologies 
          to collect this information.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">2. How We Use Your Information</h2>
        <p className="text-muted-foreground leading-relaxed">
          We use the information we collect to:
        </p>
        <ul className="list-disc list-inside text-muted-foreground leading-relaxed ml-4">
          <li>Provide, maintain, and improve our Service.</li>
          <li>Process your transactions and send you related information, including confirmations and invoices.</li>
          <li>Communicate with you about products, services, offers, promotions, and events.</li>
          <li>Monitor and analyze trends, usage, and activities in connection with our Service.</li>
          <li>Personalize and improve the Service and provide advertisements, content, or features that match user profiles or interests.</li>
          <li>Detect, investigate, and prevent fraudulent transactions and other illegal activities and protect the rights and property of Clipoid and others.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">3. How We Share Your Information</h2>
        <p className="text-muted-foreground leading-relaxed">
          We may share your information in the following circumstances:
        </p>
        <ul className="list-disc list-inside text-muted-foreground leading-relaxed ml-4">
          <li>With vendors, consultants, and other service providers who need access to such information to carry out work on our behalf.</li>
          <li>In response to a request for information if we believe disclosure is in accordance with, or required by, any applicable law, regulation, or legal process.</li>
          <li>If we believe your actions are inconsistent with our user agreements or policies, or to protect the rights, property, and safety of Clipoid or others.</li>
          <li>In connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business by another company.</li>
          <li>Between and among Clipoid and our current and future parents, affiliates, subsidiaries, and other companies under common control and ownership.</li>
          <li>With your consent or at your direction.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">4. Your Choices</h2>
        <p className="text-muted-foreground leading-relaxed">
          You may update, correct, or delete information about you at any time by logging into your account. 
          If you wish to delete or deactivate your account, please email us at support@clipoid.com, 
          but note that we may retain certain information as required by law or for legitimate business purposes.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-3">5. Contact Us</h2>
        <p className="text-muted-foreground leading-relaxed">
          If you have any questions about this Privacy Policy, please contact us at privacy@clipoid.com.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;